export default {"src":"/_next/static/media/laptop.59687bc9.svg","height":72,"width":72};